import React from "react";



const SecondPane = () => (
    <div className="uk-container uk-padding">
    <div className="uk-grid withPaddingLarge uk-margin-large-top uk-margin-large-bottom" data-uk-grid>
          <div className="uk-width-1-2@s">
                 <p className="withP uk-text-left">With the right tools, an open mindset and the proper setting, all
             children have the chance to receive top education. Schools do their 
             part, we do the rest. Always with the future in mind,</p>
          </div>

          <div className="uk-width-1-2@s">
                 <p className="uk-text-left"> we bring the 
             best tech education has to offer. We support traditional education 
             providers by offering in-depth tech courses and tutoring sessions for essential topics.</p>
          </div>
    </div>

</div>
);



export default SecondPane;